import { useQuery } from "@tanstack/react-query";
import { vehiclesService } from "../services";

export const PREVENTIVE_MAINTENANCE_QUERY_KEY =
	"vehicle-preventive-maintenance";

export const useGetPreventiveMaintenance = (vehicleId: string) =>
	useQuery({
		queryKey: [PREVENTIVE_MAINTENANCE_QUERY_KEY, vehicleId],
		queryFn: () => vehiclesService.getPreventiveMaintenance(vehicleId),
		enabled: !!vehicleId,
	});
